module.exports = __webpack_public_path__ + "static/yuan_ti_anathema-2dd071fe587ffdd3464e0d4be140e119.jpeg";